var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasAnyReasonToShow
    ? _c(
        "div",
        {
          staticClass: "padding-2xl",
          staticStyle: { "background-color": "var(--white)" },
        },
        [
          _c(
            "div",
            {
              class: [
                "message with-icon with-close roomy margin-bottom-0",
                { warning: _vm.$dt.indication === "warning" },
                { danger: _vm.$dt.indication === "danger" },
              ],
              style: `background-color: ${_vm.theme.backgroundcolor}; --hr-border-color: ${_vm.theme.bordercolor};`,
            },
            [
              _vm.$dt.indication === "warning"
                ? _c(
                    "div",
                    { staticClass: "laptop:display-flex align-between" },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "decorative fa-shake",
                        staticStyle: {
                          "--fa-secondary-opacity": "0.6",
                          "--fa-animation-delay": "0.5s",
                          "--fa-animation-iteration-count": "3",
                        },
                        attrs: {
                          icon: _vm.$v7.duotone.faMegaphone,
                          size: "3x",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _c("h1", { staticClass: "h4" }, [
                          _vm.firstName
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.firstName) + ", y"),
                              ])
                            : _c("span", [_vm._v("Y")]),
                          _vm._v("our subscription is expiring soon\n        "),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "margin-top-2xs margin-bottom-sm laptop:margin-bottom-0",
                          },
                          [
                            _vm._v("\n          Be sure to\n          "),
                            _c(
                              "site-link",
                              { attrs: { to: { name: "account.billing" } } },
                              [_vm._v("renew it in your Account")]
                            ),
                            _vm._v(
                              "\n          to keep access to Pro services, new icons, and support!\n        "
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button", "aria-label": "Close" },
                          on: { click: _vm.hideSweatband },
                        },
                        [
                          _c("font-awesome-icon", {
                            staticStyle: { "--fa-width": "auto" },
                            attrs: { icon: _vm.$v7.duotone.faCircleXmark },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$dt.indication === "danger"
                ? _c(
                    "div",
                    { staticClass: "laptop:display-flex align-between" },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "decorative fa-shake",
                        staticStyle: {
                          "--fa-secondary-opacity": "0.6",
                          "--fa-animation-delay": "0.5s",
                          "--fa-animation-iteration-count": "3",
                        },
                        attrs: {
                          icon: _vm.$v7.duotone.faMegaphone,
                          size: "3x",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _c("h1", { staticClass: "h4" }, [
                          _vm.firstName
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.firstName) + ", t"),
                              ])
                            : _c("span", [_vm._v("T")]),
                          _vm._v(
                            "here was an error when processing your payment\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "margin-top-2xs margin-bottom-sm laptop:margin-bottom-0",
                          },
                          [
                            _vm._v(
                              "We won't be able to renew your subscription until you resolve it."
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm.$dt.isStripe
                            ? _c("wa-action-button", {
                                staticClass: "button compact red",
                                attrs: { label: "Update Payment via Stripe" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.manageBilling.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$dt.isBraintree
                            ? _c(
                                "a",
                                {
                                  staticClass: "button compact margin-bottom-0",
                                  attrs: {
                                    href: "http://paypal.com",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n          Update Payment via PayPal\n          "
                                  ),
                                  _c("font-awesome-icon", {
                                    staticClass: "margin-left-xs",
                                    attrs: {
                                      icon: _vm.$v7.solid.faArrowRight,
                                      size: "lg",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button", "aria-label": "Close" },
                          on: { click: _vm.hideSweatband },
                        },
                        [
                          _c("font-awesome-icon", {
                            staticStyle: { "--fa-width": "auto" },
                            attrs: { icon: _vm.$v7.duotone.faCircleXmark },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }